import { useState } from "react";
import { useLocation } from "react-router-dom";
import { api_url } from "../../constant/constant";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function ResetPassword() {
  const location = useLocation();
  const { t } = useTranslation();

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const capitalFirstChar = /^[A-Z]/;
  const hasNumber = /\d/;
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error(t("PasswordsDoNotMatch"));
      return;
    }
    if (!capitalFirstChar.test(password)) {
      toast.error(t("FirstCharacterMustBeCapital"));
      return;
    }
  
    if (!hasNumber.test(password)) {
      toast.error(t("PasswordMustIncludeNumber"));
      return;
    }
  
    if (!hasSpecialChar.test(password)) {
      toast.error(t("PasswordMustIncludeSpecialCharacter"));
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${api_url}/password-reset/reset`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          token,
          password,
          password_confirmation: confirmPassword
        })
      });

      const data = await response.json();

      if (response.ok && data.status === "success") {
        toast.success(t("PasswordUpdated"));
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        toast.error(data.message || t("FailedToUpdatePassword"));
      }
    } catch (err) {
      toast.error(t("ErrorOccurred"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ height: '100vh' }}>
      <div className="row justify-content-center">
        <div className="col-md-5 mb-5">
          <div className="card mt-5 pb-5" style={{ borderRadius: "30px" }}>
            <div className="card-body">
              <h2 className="m-5 txtLoginAccount" align="center">
                {t("ResetPassword")}
              </h2>
              <form onSubmit={handleReset} className="px-5">
                <div className="form-group mb-3">
                  <label>{t("NewPassword")}</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={12}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>{t("ConfirmPassword")}</label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    minLength={12}
                  />
                </div>
                <button className="btn btn-dark w-100 p-2" disabled={loading}>
                  {loading ? t("Updating") : t("UpdatePassword")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
